function transformLocale(input) {
  switch (input) {
    case 'de':
      return 'de-DE';
    case 'es':
      return 'es-ES';
    case 'nl':
      return 'nl-NL';
    case 'it':
      return 'it-IT';
    case 'fr':
      return 'fr-FR';
    case 'pt':
      return 'pt-PT';
    case 'pl':
      return 'pl-PL';
    case 'da':
      return 'da-DK';
    default:
      return input;
  }
}
export class Money {
  constructor(locale, value) {
    this.value = value;
    this.locale = transformLocale(locale);
  }
  get currencyCode() {
    switch (this.locale) {
      case 'pl-PL':
        return 'PLN';
      case 'da-DK':
        return 'DKK';
      case 'sv-SE':
        return 'SEK';
      default:
        return 'EUR';
    }
  }
  getCurrencySymbol() {
    const currencySymbol = 0 .toLocaleString(this.locale, {
      style: 'currency',
      currency: this.currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).replace(/\d/g, '').trim();
    return currencySymbol;
  }
  formatWithoutCurrency() {
    const currencySymbol = this.getCurrencySymbol();
    return this.format().replace(currencySymbol, '').trim();
  }
  formatNL() {
    const formatted = this.format();
    return Number.isInteger(this.value) ? `${formatted},-` : formatted;
  }
  formatIT() {
    return `${this.getCurrencySymbol()}\xa0${this.formatWithoutCurrency()}`;
  }
  formatDE_AT() {
    return `${this.formatWithoutCurrency()}\xa0${this.getCurrencySymbol()}`;
  }
  format() {
    return new Intl.NumberFormat(this.locale, {
      style: 'currency',
      currency: this.currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(this.value);
  }
  toString() {
    switch (this.locale) {
      case 'nl-NL':
        return this.formatNL();
      case 'it-IT':
        return this.formatIT();
      case 'de-AT':
        return this.formatDE_AT();
      default:
        return this.format();
    }
  }
}
//# sourceMappingURL=money.js.map